import request from '@/utils/request'

const { bpmRunTime, bpmModel } = window.context
const model = window.context.bpmModel
const flow = window.context.bpmRunTime

// 异常任务导出
export function exportTaskException(data) {
  return request({
    url: `${flow}/runtime/bpmTaskException/v1/export`,
    method: 'post',
    data,
  })
}

// 流程监控导出
export function exportInstance(data) {
  return request({
    url: `${flow}/runtime/instance/v1/export`,
    method: 'post',
    data,
  })
}

//根据流程实例Id获取代办任务
export function getBpmTaskByInstId(instId) {
  return request({
    url: `${flow}/runtime/task/v1/getBpmTaskByInstId?instId=${instId}`,
    method: 'get',
  })
}

export function getFormPrintTemplateByForKey(formKey) {
  return request({
    url:
      model +
      `/flow/wordPrint/v1/getFormPrintTemplateByForKey?formKey=${formKey}`,
    method: 'get',
  })
}

export function getTodos(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/getTodoList`,
    method: 'post',
    data,
  })
}

export function getFillData(data) {
  return request({
    url: '/flow/todo',
    method: 'post',
    data,
  })
}

export function getStartOften(data) {
  return request({
    url: '/flow/start/often',
    method: 'post',
    data,
  })
}
//获取审批按钮
export function getApprovalButtons(query, cb) {
  const { taskId, leaderId } = query
  const url = `${bpmRunTime}/runtime/task/v1/getButtonsBytaskId?taskId=${taskId}&leaderId=${leaderId}&reqParams=`
  request.get(url).then((response) => {
    cb(response)
  })
}

//审批按钮挂起或者取消挂起
export function hangUpOrCancelHangUp(query, cb) {
  const { instId, type } = query
  const url = `${bpmRunTime}/runtime/instance/v1/${type}?instId=${instId}`
  request.get(url).then((response) => {
    cb(response)
  })
}

//获取流程状态根据defId 实例id,任务id
export function getFlowStatus(query, cb) {
  const { instId, taskId } = query
  const url = `${bpmRunTime}/runtime/instance/v1/getDefStatus?instId=${instId}&taskId=${taskId}`
  request.get(url).then((response) => {
    cb(response)
  })
}
//获取审批意见通过流程实例id和任务id
export function getBpmSaveOpinionByTeam(instId, taskId, cb) {
  const url = `${bpmRunTime}/runtime/task/v1/getBpmSaveOpinionByTeam?instId=${instId}&taskId=${taskId}`
  request.get(url).then((response) => {
    cb(response)
  })
}
//验证当前用户是否有该任务处理权限
export function checkTaskAuth(taskId) {
  const url = `${bpmRunTime}/runtime/task/v1/checkTaskAuth?taskId=${taskId}`
  return request.get(url)
}
//新增，修改或暂存审批意见
export function savaApprovalComments(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/createBpmSaveOpinion`,
    method: 'post',
    data,
  })
}

// 根据 taskId 获取任务明细
export function getNotice(taskId) {
  const url = `${bpmRunTime}/runtime/task/v1/getNotice?id=${taskId}`
  return request.get(url)
}

// 获取流程图
export function getBpmImage(instId, proInstId, defId, cb) {
  const url = `${bpmRunTime}/runtime/instance/v1/getBpmImage?taskId=&proInstId=${proInstId}&defId=${defId}&bpmnInstId=${instId}`
  request.get(url).then((res) => {
    cb(res)
  })
}

// 获取流程图promise
export function getBpmImagePromise(instId, proInstId, defId) {
  const url = `${bpmRunTime}/runtime/instance/v1/getBpmImage?taskId=&proInstId=${proInstId}&defId=${defId}&bpmnInstId=${instId}`
  return request.get(url)
}

// 获取流程实例明细
export function instanceFlowImage(data, cb, onErr) {
  const { instId, nodeId, type, defId } = data
  const url = `${bpmRunTime}/runtime/instance/v1/instanceFlowImage?proInstId=${instId}&nodeId=${
    nodeId || ''
  }&type=${type || ''}&defId=${defId || ''}`
  request
    .get(url)
    .then((res) => {
      cb(res)
    })
    .catch((e) => {
      if (typeof onErr === 'function') {
        onErr(e)
      }
    })
}

export function getInstanceFlowInfo(data) {
  const { instId, nodeId, type, defId } = data
  const url = `${bpmRunTime}/runtime/instance/v1/instanceFlowImage?proInstId=${instId}&nodeId=${
    nodeId || ''
  }&type=${type || ''}&defId=${defId || ''}`
  return request.get(url)
}

export function getNodeOpinion(data) {
  const { instId, nodeIds, defId } = data
  const url = `${bpmRunTime}/runtime/task/v1/nodeOpinion?instId=${instId}&nodeId=${nodeIds}&defId=${defId}`
  return request.get(url)
}

// 获取审批意见
export function getNodeOpinions(data, cb) {
  const { instId, nodeIds, defId } = data
  const url = `${bpmRunTime}/runtime/task/v1/nodeOpinion?instId=${instId}&nodeId=${nodeIds}&defId=${defId}`
  request.get(url).then((res) => {
    cb(res)
  })
}

// 获取我的常用流程
export function getMyOftenFlow() {
  const url = `${bpmRunTime}/runtime/instance/v1/getMyOftenFlow`
  return request.get(url)
}

// 获取所有流程
export function getHasAuthFlowList(queryFilter = {}) {
  const url = `${bpmRunTime}/runtime/instance/v1/getHasAuthFlowList`
  return request.post(url, queryFilter)
}

// 保存常用流程
export function saveMyOftenFlow(data) {
  const url = `${bpmModel}/bpmModel/BpmOftenFlow/v1/saveMyOftenFlow`
  return request.post(url, data)
}

// 当前账号是否有启动该流程的权限
export function flowHasStartRights(defKey) {
  const url = `${bpmModel}/flow/def/v1/flowHasStartRights?defKey=${defKey}`
  return request.get(url)
}

// 根据当前任务查询是否在第一个节点
export function isTaskFirstNode(taskId) {
  return request.get(
    `${bpmRunTime}/runtime/task/v1/taskIsFirstNode?taskId=${taskId}`
  )
}

// 获取流程全局打印模板
export function getFlowGlobalTemplate(defId) {
  return request({
    url: `${bpmModel}/flow/wordPrint/v1/getGlobalPrintTemplate?defId=${defId}`,
    method: 'get',
  })
}

export function getBpmPrintRecordByInstId(instId, nodeId) {
  return request({
    url: `${bpmRunTime}/runtime/bpmPrintRecord/v1/getByProInstId?procInstId=${instId}&nodeId=${
      nodeId || ''
    }`,
    method: 'get',
  })
}

export function getBpmPrintRecord(data) {
  return request({
    url: `${bpmRunTime}/runtime/bpmPrintRecord/v1/query`,
    method: 'post',
    data,
  })
}

export function getWatermarkByInstId(id) {
  return request({
    url: `${bpmModel}/bpmModel/bpmWatermark/v1/getByInstId?instId=${id}`,
    method: 'get',
  })
}

export function savePrintRecord(data) {
  return request({
    url: `${bpmRunTime}/runtime/bpmPrintRecord/v1/printLog`,
    data,
    method: 'post',
  })
}

export function getInstanceStatus(id) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/getInstanceStatus?instId=${id}`,
    method: 'get',
  })
}

export function getVarTree(data) {
  return request({
    url: `${window.context.bpmModel}/flow/node/v1/varTree`,
    method: 'post',
    data,
  })
}

export function getInstFormDataVersion(instId) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getInstFormDataVersion?instId=${instId}`,
    method: 'get',
  })
}

export function getTaskExceptionList(data) {
  return request({
    url: `${bpmRunTime}/runtime/bpmTaskException/v1/list`,
    method: 'post',
    data,
  })
}

export function getInstDetailList(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getInstDetailList`,
    method: 'post',
    data,
  })
}

export function getTaskDetailBo(query) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/taskDetailBo?taskId=${query.taskId}&reqParams=${query.reqParams}&leaderId=${query.leaderId}`,
  })
}

//获取后续可跳转节点
export function getAfterJumpNodesByDefId(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/getAfterJumpNodes`,
    method: 'post',
    data,
  })
}

//处理任务
export function savaTaskComplete(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/complete`,
    method: 'post',
    data,
  })
}

export function deleteTaskException(data) {
  return request({
    url: `${bpmRunTime}/runtime/bpmTaskException/v1/delete`,
    method: 'DELETE',
    data,
  })
}

export function getInstPage(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getInstDetailList`,
    method: 'post',
    data,
  })
}

export function getInstOverviewList(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getInstOverviewList`,
    method: 'post',
    data,
  })
}

export function deleteInstance(ids) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/remove?ids=${ids}`,
    method: 'DELETE',
  })
}

export function instanceFlowOpinions(id) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/instanceFlowOpinions?instId=${id}`,
    method: 'get',
  })
}

export function updateFlowOpinions(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/updateFlowOpinions`,
    method: 'post',
    data,
  })
}

export function modifyRecordList(data) {
  return request({
    url: `${bpmRunTime}/bpm/boDataModifyRecord/v1/listJson`,
    method: 'post',
    data,
  })
}

export function deleteRecord(data) {
  return request({
    url: `${bpmRunTime}/bpm/boDataModifyRecord/v1/remove`,
    method: 'DELETE',
    data,
  })
}

export function getUrgentStateConf(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getUrgentStateConf`,
    method: 'post',
    data,
  })
}

export function saveFormData(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/saveFormData`,
    method: 'post',
    data,
  })
}

export function getProcessTitle(defId) {
  return request({
    url: `${model}/flow/def/v1/getDefDesignByDefId?defId=${defId}`,
    method: 'get',
  })
}

export function getMessageTypes() {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/handlerTypes`,
    method: 'get',
  })
}

export function setTaskExecutors(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/setTaskExecutors`,
    method: 'post',
    data,
  })
}

export function getTaskList(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/list`,
    method: 'post',
    data,
  })
}

// 自动授权代理接口
export function agentToTina(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/agentToTina`,
    method: 'post',
    data,
  })
}

// 查询代理授权记录
export function getAgentAutoList(data) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/getAgentAutoList`,
    method: 'post',
    data,
  })
}

// 取消授权
export function cancelAgent(ids) {
  return request({
    url: `${bpmRunTime}/runtime/task/v1/withdrawAgent`,
    method: 'post',
    data: ids,
  })
}

// AI日志埋点
export function aiLog(data) {
  return request({
    url: `${bpmRunTime}/runtime/bpmTaggedEventLog/v1/createAISummaryTinaTaggedEventLog`,
    method: 'post',
    data,
  })
}

// SP17数据埋点
export function sp17Log(data) {
  return request({
    url: `${bpmRunTime}/runtime/bpmTaggedEventLog/v1/createSp17FeishuCardLinkTaggedEventLog`,
    method: 'post',
    data,
  })
}

// AI分析点赞或点踩
export function AiResultLike(data) {
  return request({
    url: `${bpmRunTime}/bpm/like/addOrUpdateLikeRecord`,
    method: 'post',
    data,
  })
}

// 查询点赞点踩
export function getLikeRecord(ids) {
  return request({
    url: `${bpmRunTime}/bpm/like/getLikeListByRefId`,
    method: 'get',
    params: {
      ids,
    },
  })
}

// 查询首页相关流程
export function homePageRelatedProcess(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/homePageRelatedProcess`,
    method: 'post',
    data,
  })
}

//查询首页文控相关文档
export function queryDocList(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/queryDocList`,
    method: 'post',
    data,
  })
}
